<div class="container py-5" style="max-width: 520px;">
  <div class="text-center mb-4">
    <h2 class="fw-bold mb-1" [routerLink]="['/']" style="cursor:pointer">SwipFx</h2>
    <div class="text-muted">Sign in to continue</div>
  </div>

  <div *ngIf="error" class="alert alert-danger" role="alert">{{ error }}</div>

  <form class="card shadow-sm border-0" [formGroup]="form" (ngSubmit)="submit()">
    <div class="card-body p-4">
      <div class="btn-group w-100 mb-4" role="group" aria-label="Login method">
        <button type="button" class="btn" [class.btn-primary]="mode === 'password'"
          [class.btn-outline-primary]="mode !== 'password'" (click)="setMode('password')">
          Password
        </button>
        <button type="button" class="btn" [class.btn-primary]="mode === 'pin'"
          [class.btn-outline-primary]="mode !== 'pin'" (click)="setMode('pin')">
          Account PIN
        </button>
      </div>

      <div class="mb-3">
        <label class="form-label">Email</label>
        <input type="email" class="form-control" formControlName="email" autocomplete="email"
          placeholder="you@example.com" [class.is-invalid]="submitted && form.controls.email.invalid" />
        <div class="invalid-feedback">Enter a valid email address.</div>
      </div>

      <div class="mb-2" *ngIf="mode === 'password'">
        <label class="form-label">Password</label>
        <input type="password" class="form-control" formControlName="password" autocomplete="current-password"
          placeholder="••••••••" [class.is-invalid]="submitted && form.controls.password.invalid" />
        <div class="invalid-feedback">Password is required.</div>
      </div>

      <div class="mb-2" *ngIf="mode === 'pin'">
        <app-account-pin-pad
          [(pin)]="loginPin"
          title="Enter your account PIN"
          description="Use the PIN pad to enter the six-digit PIN configured in Account Security."
          confirmLabel="Sign in with PIN"
          [loading]="loading"
          (pinSubmit)="submit($event)">
        </app-account-pin-pad>

        <div class="form-text text-center mt-2">
          PIN login must first be enabled in Account Security.
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center mb-3 mt-3">
        <a class="small text-decoration-none" routerLink="/auth/forgot-password">Forgot password?</a>
        <a class="small text-decoration-none" routerLink="/auth/register">Create an account</a>
      </div>

      <button
        type="button"
        class="btn btn-link btn-sm w-100 text-decoration-none mb-2"
        (click)="openReactivationHelp()">
        Reactivate a deactivated account
      </button>

      <button *ngIf="mode === 'password'" class="btn btn-primary w-100" type="submit" [disabled]="loading">
        <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
        {{ loading ? 'Signing in...' : 'Sign in' }}
      </button>
    </div>
  </form>

  <div class="text-center mt-3 text-muted small">
    By continuing, you agree to SwipFx terms.
  </div>
</div>
